// localStorage throws in Safari private mode, when the quota is full and in
// some embedded contexts. Stored values are conveniences — never worth a
// crash. Callers that must know whether the write stuck (e.g. the auth token)
// check the returned boolean.
export function safeSetItem(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeRemoveItem(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    // nothing sensible to do
  }
}
